// app/javascript/controllers/manufacturing/stock_deductions_controller.js
import ApplicationController from '../application_controller';
import Rails from "@rails/ujs";

export default class extends ApplicationController {
  static targets = [
    'searchInput',
    'searchFilterForm',
    'quantityInput',
    'breakdown',
    'requiredAmount',
    'currentStock',
    'afterDeduction',
    'submitButton',
    'deductionForm'
  ]

  static values = {
    stockId: String,
    hwPartId: String
  }

  search(event) {
    event.preventDefault();
    this.setRequestId();
    this.spinnerOn(this.spinnerTarget);
    Rails.fire(this.searchFilterFormTarget, 'submit');
  }

  searchResult(event) {
    event.preventDefault();
    this.spinnerOff(this.spinnerTarget);

    if (this.requestId == event.detail[0].body.querySelector('#request_id').value) {
      this.replaceElementWithNewBySingleQuery('.products-hw-parts-list', event);
      this.pushQueryParamsToUrl(this.searchFilterFormTarget);
      this.searchInputTarget.focus();
    }
  }

  updateCalculations(event) {
    const quantity = parseInt(this.quantityInputTarget.value) || 1;

    this.requiredAmountTargets.forEach(element => {
      const stockHwPartId = element.dataset.stockHwPartId;
      const perUnit = parseFloat(element.dataset.perUnit);
      const totalRequired = perUnit * quantity;

      element.textContent = totalRequired;

      const currentStockElement = this.currentStockTargets.find(
        el => el.dataset.stockHwPartId === stockHwPartId
      );
      const afterDeductionElement = this.afterDeductionTargets.find(
        el => el.dataset.stockHwPartId === stockHwPartId
      );

      if (currentStockElement && afterDeductionElement) {
        const currentStock = parseFloat(currentStockElement.textContent);
        const afterDeduction = currentStock - totalRequired;
        afterDeductionElement.textContent = afterDeduction;

        const row = element.closest('.material-row');
        if (afterDeduction >= 0) {
          row.classList.remove('insufficient');
          row.classList.add('sufficient');
          row.querySelector('.status .badge')?.classList.replace('badge-danger', 'badge-success');
        } else {
          row.classList.remove('sufficient');
          row.classList.add('insufficient');
          row.querySelector('.status .badge')?.classList.replace('badge-success', 'badge-danger');
        }
      }
    });

    this.updateSubmitButton();
  }

  updateSubmitButton() {
    const hasInsufficientItems = document.querySelectorAll('.material-row.insufficient').length > 0;

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = hasInsufficientItems;

      if (hasInsufficientItems) {
        this.submitButtonTarget.title = 'Nelze odečíst - nedostatečné množství některých komponent';
      } else {
        this.submitButtonTarget.title = '';
      }
    }
  }
}
